/**
 * GET /bots/trial-eligibility body. Axios helpers sometimes leave it nested
 * under `.data`; callers should always go through this unwrap.
 */
export function unwrapTrialEligibilityPayload(payload) {
  if (!payload || typeof payload !== "object") return null;
  if (
    payload.eligible === undefined &&
    payload.data &&
    typeof payload.data === "object"
  ) {
    return payload.data;
  }
  return payload;
}

/** Show the Trial engine / CTA when the user has not used their free trial. */
export function isEligibleForTrialDisplay(payload) {
  const body = unwrapTrialEligibilityPayload(payload);
  if (!body) return false;
  if (body.trialUsed === true) return false;
  return body.eligible === true;
}

/** Map GET /bots/trial-eligibility into CreateBot local state. */
export function trialEligibilityStateFromPayload(payload) {
  const body = unwrapTrialEligibilityPayload(payload);
  if (!body) {
    return {
      loading: false,
      eligible: false,
      message: "Could not verify trial eligibility",
      code: null,
    };
  }
  return {
    loading: false,
    eligible: body.eligible === true,
    message: body.message || null,
    details: body.details || null,
    code: body.code || null,
    reason: body.reason || null,
    systemFunded: body.systemFunded,
  };
}
